module.exports = __webpack_public_path__ + "static/img/Three_of_a_kind.cc30480.svg";